// extracted by mini-css-extract-plugin
export default {"mainContainer":"Textcomponent_mainContainer__4J4wU","redLine":"Textcomponent_redLine__nTGis","heading":"Textcomponent_heading__Udm8V","Content":"Textcomponent_Content__zAFVh"};